import { APP_CONFIG } from "../config/appConfig";

/**
 * Returns base price for a plan
 */
export function getPlanPrice(planId) {
  return APP_CONFIG.PRICES.plans[planId] || 0;
}

/**
 * Returns blockchain surcharge
 */
export function getBlockchainPrice(planId, blockchains = []) {
  if (planId !== "custom") return 0;
  return blockchains.length * APP_CONFIG.PRICES.blockchainUnitPrice;
}

/**
 * Returns total price
 */
export function getTotalPrice(planId, blockchains = []) {
  return (
    getPlanPrice(planId) +
    getBlockchainPrice(planId, blockchains)
  );
}


/**
 * Returns commission from a given amount
 */
export function getCommission(amount) {
  return Number((amount * APP_CONFIG.COMMISSION_RATE).toFixed(2));
}

/**
 * Custom plan minimum price:
 * base + 1 blockchain unit
 */
export function getCustomMinPrice() {
  return (
    getPlanPrice("custom") +
    APP_CONFIG.PRICES.blockchainUnitPrice * 1
  );
}

/**
 * Custom plan maximum price:
 * base + 7 blockchain units
 */
export function getCustomMaxPrice() {
  return (
    getPlanPrice("custom") +
    APP_CONFIG.PRICES.blockchainUnitPrice * 7
  );
}